export const MINIMUM_GAS_PRICE_WEI = 100_000_000
export const EVM_DEFAULT_FEE_ETH = 0.005
export const EVM_GAS_BUFFER_MULTIPLIER = 2
export const EVM_DEFAULT_GAS_LIMIT = 400_000
export const SOLANA_FEE_BUFFER_MULTIPLIER = 5
export const SOLANA_DEFAULT_FEE_SOL = 0.001
export const GAS_BUFFER_CACHE_MINUTES = 5
export const WEI_PER_ETH = 1_000_000_000_000_000_000
